module.exports = __webpack_public_path__ + "img/11.df106041.png";